/* eslint-disable @typescript-eslint/ban-ts-comment */
import { AxiosResponse } from "axios";
import { Filter } from "@mm-products/java-multima-framework";
import { taxGuruAxios } from "../axios";
import { taxAccountantOnboardingUrls } from "../url";
import { TaxAccountantOnboardingRequest } from "../models/TaxAccountantOnboardingRequest";
import { TaxAccountantOnboardingResult } from "../models/TaxAccountantOnboardingResult";

export const submitAccountantOnboarding = (req: TaxAccountantOnboardingRequest, toastId?: string): Promise<void> => {
    return taxGuruAxios
        .post(taxAccountantOnboardingUrls.submit, req, {
            // @ts-ignore
            toastId,
        })
        .then(() => undefined);
};

export const listAccountantOnboardings = (filter: Filter, signal?: AbortSignal, toastId?: string): Promise<AxiosResponse<TaxAccountantOnboardingResult>> => {
    return taxGuruAxios.post(taxAccountantOnboardingUrls.filter, filter, {
        signal,
        // @ts-ignore
        toastId,
    });
};
